<div class="layout-main">
  <div class="settings-card-container">
    <div class="settings-card-options" role="tablist">
      @for (option of options; track option) {
        <div class="settings-title-option"
             role="tab"
             [attr.aria-selected]="selectedOption === option"
             [class.active]="selectedOption === option"
             (click)="selectOption(option)"
             tabindex="0"
             (keydown.enter)="selectOption(option)"
             (keydown.space)="selectOption(option)">
          {{ option | translate }}
        </div>
      }
    </div>

    <!-- Settings content area using @if -->
    <div class="settings-content">
      @if (selectedOption === options[0]) {
        <div role="tabpanel">
          <app-security-settings-form/>
        </div>
      }
      @if (selectedOption === options[1]) {
        <div role="tabpanel">
          <app-email-settings-form/>
        </div>
      }
      @if (selectedOption === options[2]) {
        <div role="tabpanel">
          <app-forwarding-settings-form/>
        </div>
      }
    </div>
  </div>
</div>
